import React, { useState } from "react";
import binance from "../../assets/payIcon/icon_binance.png";
import bitcoin from "../../assets/payIcon/icon_bitcoin.png";
import dogecoin from "../../assets/payIcon/icon_dogecoin.png";
import tron from "../../assets/payIcon/icon_tron.png";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";
const icon = [
  { icon: binance, name: "binance" },
  { icon: bitcoin, name: "bitcoin" },
  { icon: dogecoin, name: "dogeicon" },
  { icon: tron, name: "tron" },
];
const AddFundPage = () => {
  const [data, setData] = useState({
    tron_value: "",
    tron_wallet: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  const handleChange = (e) => {
    setData({
      ...data,
      tron_wallet: e.target.value,
    });
  };
  return (
    <div className="mono_add_funds_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_add_funds_card"
      >
        <div className="mono_section_title">
          <h2>Add Fund</h2>
        </div>
        <div className="mono_add_funds_page_content">
          <form onSubmit={handleSubmit}>
            <div className="tron_input_field">
              <Input
                label="Tron (TRX)"
                type="text"
                name="tron_value"
                placeholder="Enter tron (TRX) value"
                onChange={(e) =>
                  setData({ ...data, tron_value: e.target.value })
                }
                className="tron_input"
              />
              <div className="notice">
                <p>Enter Tron Value To Add In To Your Wallet.</p>
              </div>
            </div>
            <div className="wallet_icon_title">
              <p>payment mode *</p>
            </div>
            <div className="wallet_icon">
              {icon.map((d, i) => (
                <>
                  <div key={i + 100} className="form-check form-check-label input_wrapper">
                    <Input
                      type="radio"
                      className="form-check-input form-check-label icon_input"
                      name="tron_wallet"
                      value={d.name}
                      id={d.name}
                      disabled={false}
                      onChange={handleChange}
                    />
                    <label htmlFor={d.name} className="form-check-label">
                      <div className="icon">
                        <img src={d.icon} alt="icon" />
                      </div>
                      <div className="name">{d.name}</div>
                    </label>
                  </div>
                </>
              ))}
            </div>
            <Button type="submit" className="submit_btn">
              submit
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default AddFundPage;
